import React from "react"
import {MainCP} from "../../Components/gasto-hogares-clase-media/MainCP"

const ViewGastoHogaresClaseMedia: React.FC = () => <MainCP/>

export default ViewGastoHogaresClaseMedia;